<template>
    <div class="screen">
        <div class="header">
            <div class="header-logo">
            <img src="../../assets/images/common/esof_logo.png" style="height: 30px; vertical-align: middle;" />
            <span style="margin-left:3px; margin-right:5px; color: #ffffff; font-weight: 700; "> x </span>
            <img src="../../assets/images/common/scratch_logo.png" style="height: 30px; vertical-align: middle;"/> 
            </div>
            <div class="header-title">
                <input type="text" class="inputBox" placeholder="작품명을 입력해주세요." v-model="prctice_nm" maxlength="30">
            </div>
            <div class="menubox">
                <div class="dropdown">
                    <!-- Vue Header에서 저장 Button Click Event 등록 -->
                    <button class="dropbtn" type="button" @click.prevent="showDc = true"><i class="material-icons">description</i> 실습설명</button>
                </div>
                <div class="dropdown">
                    <!-- Vue Header에서 저장 Button Click Event 등록 -->
                    <button class="dropbtn" type="button" @click.prevent="showModalGuide"><i class="material-icons">subject</i>가이드(힌트)</button>
                </div>
                <div class="dropdown">
                    <!-- Vue Header에서 열기 Button Click Event 등록 -->
                    <button class="dropbtn" type="button" @click.prevent="showResult"><i class="material-icons">play_circle_filled</i>결과보기</button>
                </div>
                <div class="dropdown">
                    <!-- Vue Header에서 저장 Button Click Event 등록 -->
                    <button class="dropbtn" type="button" @click.prevent="showSendResultModal = true"><i class="material-icons">check_circle</i>제출</button>
                </div>
                <div class="dropdown">
                    <!-- Vue Header에서 저장 Button Click Event 등록 -->
                    <button class="dropbtn" type="button" @click.prevent="reloadProject"><i class="material-icons">settings_backup_restore</i>재시작</button>
                </div>                
                <!-- <div class="modal-alert-header-close" @click.prevent="pageBack"></div> -->
            </div>
        </div>

        <modal-alert2 v-if="showAlertModalLogin" @close="showAlertModalLogin= false">
            <div slot="text">해당 기능을 이용하려면 로그인이 필요합니다.</div>
        </modal-alert2>

            
        <modal-alert v-if="showAlert" @close="showAlert= false" :funcData="reloadProjectOk" headerColor="#5bc36e">
            <div slot="text">재시작 하시겠습니까?</div>
        </modal-alert>

        <modal-alert v-if="showSendResultModal" @close="showSendResultModal= false" :funcData="showSendResultAndSave" headerColor="#5bc36e" >
            <div slot="text">학습한 내용을 제출하시겠습니까?</div>
        </modal-alert>

        <modal-alert v-if="showNewFile" @close="showNewFile = false" :funcData="newFileOption">
            <div slot="text">새로운 작품을 생성하시겠습니까? 저장하지 않은 데이터는 사라집니다.</div>
        </modal-alert>

        <modal-alert2 v-if="showGuideAlert" @close="showGuideAlert = false" headerColor="#5bc36e">
            <div slot="text">가이드(힌트)가 존재하지 않습니다.</div>
        </modal-alert2>
        
        <modal-learning-guide v-if="showGuide" @close="showGuide= false" :guideData="guideData"></modal-learning-guide>
        <modal-learning-guide-full v-if="showGuideFull" @close="showGuideFull= false" :guideData="guideData"></modal-learning-guide-full>
        
        <modal-learning-dc v-if="showDc" @close="showDc= false" headerColor="#5bc36e">
            <div slot="text">{{this.prctice_dc}}</div>
        </modal-learning-dc>

        <modal-learning-result v-if="showModalResult" @close="showModalResult = false" :beginInfo="beginInfo"></modal-learning-result>
    </div>
</template>

<script>
import axios from 'axios';
import ModalAlert from '../Common/Modal/Alert.vue'
import ModalAlert2 from '../Common/Modal/Alert2.vue';

import ModalLearningDc from '../Common/Modal/LearningDc';
import ModalLearningGuideFull from '../Common/Modal/LearningGuideFull';
import ModalLearningGuide from '../Common/Modal/LearningGuide';
import ModalLearningResult from '../Common/Modal/LearningResult';

import { APIURL, BASEURL, getCookie } from '../../data/config';

export default {
    name: 'Header',
    props: ['value'],
    components: {
        'modal-alert': ModalAlert,
        'modal-alert2': ModalAlert2,
        // 'modal-learning-guide': ModalLearningGuide,
        'modal-learning-dc': ModalLearningDc,
        'modal-learning-guide': ModalLearningGuide,
        'modal-learning-guide-full': ModalLearningGuideFull,
        'modal-learning-result': ModalLearningResult

    },
    data() {
        return {
            sessionOK: false,
            showAlert: false,
            showGuide: false,
            showGuideFull: false,
            showDc: false,
            showNewFile: false,
            showModalSprite : false,
            showModalSound : false,
            showModalPicture: false,
            showGuideAlert: false,
            showSendResultModal: false,
            showModalResult: false,
            showAlertModalLogin: false,
            lectureInfo: {},
            beginInfo: null,
            projectData: '',
            initOption : {},
            guideData: [],
            prctice_nm : '',
            prctice_dc : '',
            sceneTitle : '큰 작품',
            dffly_code_text : '상',
            lecture : false,
            categoryList : [],
            cntntsSn : 0,
            USER_SN : 0,
            USER_ID : 0,
            fullscreen : false,
            learningLog: {
                block: null,
                sound: null,
                picture: null,
                activities: null
            }
        }
    },
    mounted() {
        // 60000 * 25마다 세션 체크
        setInterval(function(){
            axios.post(
                APIURL+'/manage/common/session/check',
                {jsession_id : getCookie},
                {
                    headers : {
                        'Content-Type': 'application/json',
                        'LbCookie': document.cookie
                    },
                }
            ).then((response)=>{
                if(response.status==200){

                    if(response.data.code === "1000"){
                        if(response.data.user_sn){
                            that.USER_SN = parseInt(response.data.user_sn);
                            that.USER_ID = parseInt(response.data.user_id);
                        }

                    }
                }
            }).catch(function (error) {
            });
        },60000 * 25)

        // 실습 이름
        this.prctice_nm = '가상실습환경';
        const query = this.$route.query;
        var that = this;
        that.sessionOk = true;
        this.$EventBus.$on('Learning Loading Complete', ()=>{
            if(query.cntntsSn){
                this.cntntsSn = query.cntntsSn;
                axios.get(
                    APIURL + '/manage/scrtc/cntnts',
                    {
                        params: {
                            cntnts_sn : this.$route.query.cntntsSn,
                            lctre_sn : this.$route.query.lctreSn
                        },
                        headers : {
                            'Content-Type': 'application/json',
                            'LbCookie': document.cookie
                        },
                    }
                ).then(async function(res){
                    if(res.status==200){
                        const { result, code, msg } = res.data;
                        if(code === "1000"){
                            that.USER_SN = result.user_sn;
                            that.USER_ID = result.user_id;
                            that.lecture = false;
                            // 기존
                            //that.projectData = result.lctre_blck_info;
                            //that.beginInfo = result.begin_blck_info ? result.begin_blck_info : null;
                            // 신규(2021.04.20 - 강의시작,강의예제 뒤바뀜 수정)
                            that.projectData = result.begin_blck_info ? result.begin_blck_info : null;  // 강의예제
                            that.beginInfo = result.lctre_blck_info;        // 강의시작
                            that.categoryList = result.lctre_factor_info;
                            that.guideData = result.guide_info;
                            that.prctice_nm = result.prctice_nm;
                            that.prctice_dc = result.prctice_dc;
                            that.showDc = true;
                            // that.sceneTitle = that.projectData.title;


                            // 자바스크립트에서 빈 객체({})는 true이기 때문에 위 코드는 사용하면 안됨.
                            const getLearningData = await that.getLearingInfo(that.$route.query.lctreSn);
                            
                            let learningInfo = undefined;
                            if (Object.keys(getLearningData.lrnManageInfo).length !== 0) {
                                learningInfo = getLearningData.lrnManageInfo.lrnBlckInfo;
                                that.scratchLoad(learningInfo); // 여기서 스크래치 파일 로드
                            } else {
                                that.scratchLoad(that.projectData);
                            }
                        }else{
                            alert('정보가 존재하지 않습니다.');
                        }
                    }
                }).catch(function(e){
                    if(e.err){
                        alert(e.message);
                    }else {
                        alert('해당 정보가 존재하지 않습니다.');
                    }
                    
                });
            }else{
                alert('잘못된 접근입니다.');
            } 
        });

        window.onclick = function(event) {
            if (!event.target.matches('.dropbtn')) {
                var dropdowns = document.getElementsByClassName("dropdown-content");
                var i;
                for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                    }
                }
            }
        }
        window.addEventListener('message', (e) => {
            // origin이 Child(React)에서 올 때만 리스너 동작.
            // 해당 코드가 없으면 자신의 윈도우에서 알 수 없는 이벤트 발생.
            if (e.data.host === 'React') {
                // 저장에 대한 Post Message 이후 Scratch로 부터 응답 받는 코드.
                if (e.data.sender === 'Scratch Learning Save Receiver') {
                    this.scratchSaveReceiver(e.data.files, e.data.saveEvent)
                // 저장 테스트 버전 리시버 (리액트로 부터)
                } else {
                    // console.log('알 수 없는 요청', e)
                }
            }
        });
    },
    methods: {
        scratchLoad(projectData) {
            axios.get(projectData)
                .then(res => {
                    const sliceSize = 512;
                    const b64Data = res.data;

                    const byteCharacters = atob(b64Data);
                    const byteArrays = [];
                    
                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);
                    
                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }
                    
                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }
                    
                    const blob = new Blob(byteArrays);

                    const reader = new FileReader();

                    reader.readAsArrayBuffer(blob);

                    if (reader) {
                        reader.onload = () => {
                            this.value.contentWindow.postMessage({
                                'sender': 'Load',
                                'blobData': reader.result,
                                'host': 'Vue' // origin 구별하기 위한 코드.
                            }, '*')
                        };
                    }
                })
                .catch(err => {
                    // console.log(err)
                })
        },
        getLearingInfo(lctreSn) {
            return new Promise((resolve,reject) => {
                axios.get(
                    APIURL + "/manage/scrtc/lrn",
                    {
                        params: {
                            trget: 'student',
                            lctre_sn: lctreSn
                        },
                        headers : {
                            'Content-Type': 'application/json',
                            'LbCookie': document.cookie
                        },
                    }
                ).then(response => {
                    if(response.status == 200) {
                        if(response.data.code === "1000"){
                            resolve(response.data);
                        }else {
                            reject({err: true, message: '과제 제출 조회에 실패하였습니다.'})
                        }
                    }else {
                        reject({err: true, message: '서비스 접속 에러 입니다. 관리자에게 문의 바랍니다.'});
                    }
                })
            })
        },
        resetWorkspace() {
            this.value.contentWindow.postMessage({
                'sender': 'Reset',
                'host': 'Vue' // origin 구별하기 위한 코드.
            }, '*')
        },
        newFileOption(){
            this.prctice_nm= '';
            this.resetWorkspace()
            this.showNewFile = false;
        },
        onlineOpenFile(){
            // console.log('서버에 저장하기');
        },
        offlineOpenFile(){
            // console.log('파일 생성하기');
        },

        reloadProject(){
            this.showAlert = true;
            // Entry.clearProject();
            // Entry.loadProject();
        },
        reloadProjectOk(){
            if(this.projectData){
                this.scratchLoad(this.projectData)
            }else{
                this.resetWorkspace()
            }
            this.showAlert = false;
        },
        scratchSave(saveEvent) {
            this.value.contentWindow.postMessage({
                'sender': 'Save',
                'eventMessage': 'Scratch Learning Save',
                'host': 'Vue', // origin 구별하기 위한 코드.
                'saveEvent': {
                    'type': saveEvent,
                    'action': 'create'
                }
            }, '*')
        },
        scratchSaveReceiver(files, saveEvent) {
            const that = this;

            const {block, img} = files;

            const blockToBase64 = (block, cb) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const dataUrl = reader.result;
                    const base64 = dataUrl.split(',')[1];
                    cb(base64);
                };
                reader.readAsDataURL(block);
            };

            blockToBase64(block, (base64) => {
                if (saveEvent.type === 'submit') {
                    that.showSendResult(base64)
                }
                else if (saveEvent.type === 'result') {
                    // this.beginInfo = base64;
                    // this.showModalResult = true;
                }
            })
        },
        showSendResultAndSave() {
            this.scratchSave('submit')
        },
        showSendResult(exportData) {
            var that = this;
            var data = {
                "atnlc_no": this.$route.query.atnlcNo,
                "lctre_sn": this.$route.query.lctreSn,
                "lrn_blck_info": exportData,
                "blck_use_co": this.learningLog.block,
                "shape_use_co": this.learningLog.picture,
                "sound_use_co": this.learningLog.sound,
                "sess_sn": this.$route.query.sessSn
            }
            axios.post(
                APIURL+'/manage/scrtc/lrn',
                data,
                {headers: {'Content-Type': 'application/json', 'LbCookie': document.cookie }}
            ).then(function(response){
                if(response.status == 200 && response.data.code == 1000){
                                        
                    var stepSn = that.getLocation("stepSn");
                    var formData = new FormData();
                    formData.append("atnlcNo",that.$route.query.atnlcNo);
                    formData.append("stepSn", stepSn);
                    formData.append("lctreSn",that.$route.query.lctreSn);
                    formData.append("cntntsTyCode", "003");
                    // Mooc형 강좌일때(sessSn인 기수정보)만 Ubion에도 함께 발송처리
                    if(that.$route.query.sessSn){
                        formData.append("sessSn", that.$route.query.sessSn);
                    }
                    axios.post(
                        '/mypage/userlrn/taskSubmit.do',
                        formData
                    ).then(function(response) {
                        alert('학습 제출이 완료 되었습니다.')
                    })
                    // 무엇
                    window.parent.lctreLrnSave("CHECK") 
                    // document.opener.reload();

                }else if(response.data.code == "2011"){
                    alert('이미 제출이 완료된 학습입니다.');
                }else if(response.data.code == "2006"){
                    that.showAlertModalLogin = true;
                    // alert('에러가 발생하였습니다.')
                }else {
                    alert('제출에 실패하였습니다. 관리자에게 문의 부탁드립니다.')
                }
            }).catch(function(e){
                // console.log(e);
                alert(e);
            })
            this.showSendResultModal = false;
        },
        showFile(){
            this.hideDropdownContent();
            document.getElementById("fileDropdown").classList.toggle("show");
        },
        showModalNewFile(){
            this.showNewFile = true;
        },
        showSave(){
            this.hideDropdownContent();
            document.getElementById("saveDropdown").classList.toggle("show");
        },
        showReload(){
            this.hideDropdownContent();
        },
        showShare(){
            this.hideDropdownContent();
        },
        hideDropdownContent(){
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for (i = 0; i < dropdowns.length; i++) {
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains('show')) {
                    openDropdown.classList.remove('show');
                }
            }
        },
        showModalGuide(){
            
            if(_.size(this.guideData) > 0){
                this.showGuide = true;
                // this.showGuideFull = true;
                this.hideDropdownContent();
            }else{
                this.showGuideAlert = true;
                // alert('등록된 가이드가 존재하지 않습니다.');
            }
            
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            try{
                return new File([u8arr], filename, {type:mime});
            }catch(e){
                return new Blob([u8arr],{type:mime});
            }
        },

        pageBack(){
            if(confirm("실습화면을 닫으시겠습니까?")){
                window.location.href= "/"
            }
            
        },
        getSession(){
            const getCookie = this.getCookie('JSESSIONID');
            const that = this;
            // 접속 정보 체크 
            axios.post(
                APIURL+'/manage/common/session/check',
                {jsession_id : getCookie},
                {
                    headers : {
                        'Content-Type': 'application/json',
                        'LbCookie': document.cookie
                    },
                }
            ).then((response)=>{
                that.chkQuery();
                if(response.status==200){
                    if(response.data.code === "1000"){
                        if(response.data.user_sn){
                            that.USER_SN = response.data.user_sn;
                            that.USER_ID = response.data.user_id;
                            // that.sessionOK = true;
                        }else{
                            alert('접속 정보가 존재하지 않습니다.');
                            window.location.href= "/";
                        }
                    }else{
                        alert('접속 정보가 존재하지 않습니다.');
                        window.location.href= "/";
                    }
                    
                }
            }).catch(function (error) {
                alert('접속 정보가 존재하지 않습니다.');
                window.location.href= "/";
                return;
            });
        },
        getCookie (name) {  /// Retrieve cookie function
            var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
            if (match) return match[1];
            return
        },

        getLocation(name) {
            // 무엇
            var query = window.parent.location.href;

            var vars = query.split("&");
            // console.log(vars);
            for(var i=0; i< vars.length; i++){
                var pair = vars[i].split("=");
                if(pair[0] == name){
                    return pair[1]
                }
            }
        },

        fullScreenToggle() {
            this.$fullscreen.toggle(this.$el.querySelector('#workspace'), {
                wrap: true,
                callback: this.fullscreenChange
            })
        },
        fullscreenChange(f){
            this.fullscreen = f
        },
        showResult(saveEvent) {
            // this.scratchSave('result')
            this.showModalResult = true;
        },
        showAlertLogin(data) {
            this.showAlertModalLogin = data;
        }
    }
}
</script>

<style lang="scss">
    .header {
        width: 100%;
        height: 50px;
        background-color: #5096f5;
        overflow: visible;
        /* 디버그용 */
        // border: 1px inset red;  
    }
    .header:after {
        clear:both;
        display:block;
    }
    .header-logo{
        display: inline-block;
        float:left;
        cursor: pointer;
        margin-top:10px;
        margin-left: 17px;
        margin-right:0px;
        margin-bottom:0px;
        padding: 0px;
        width: 240px;
        height: 30px;
        /* 디버그용 */
        // background-color: red;
    }
    .header-title { 
        /* position:relative; */
        padding: 8px;
        float:left;
        display:inline-block;
        width:460px;
        margin-left:0px;
        // background-color: blue;
    }
    // Scratch가 지원하는 최대 width가 약 1135px
    @media (max-width: 1135px) {
        .header-title {
            width: 350px;
        }
    }

    .inputBox {
        display: inline-block;
        width: 100%;
        height: 34px;
        padding: 0 10px;
        vertical-align: middle;
        border: 0px;
        color: #fff;
        font-weight: 900;
        font-size: 16px;
        background-color: #5096f5;
        font-family: "Noto Sans KR";
    }


    .inputBox:focus {
        background-color: #fff;
        border: 1px solid #888;
        color: #000;
    }

    .menubox {
        display:inline;
        float:right;
        /* padding:8px; */
        background-color: #5096f5;
    }
    .menubox > div {
        float:left;
    }

    i { 
        vertical-align: text-top;
        font-size: 18px;
        line-height: 24px;
        margin-top:2px;
    }

    
    /* Dropdown Button */
    .dropbtn {
        // /* background-color: #3498DB; */
        color: white;
        background-color: #5096f5;
        // background-color: red;
        padding: 8px;
        font-size: 16px;
        border: none;
        margin-top:2px;
        cursor: pointer;
    }  

    /* The container <div> - needed to position the dropdown content */
    .dropdown {
        position: relative;
        display: inline-block;
        // background-color: #5096f5;
    }

    /* Dropdown Content (Hidden by Default) */
    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #f1f1f1;
        // background-color: #5096f5;
        min-width: 160px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        z-index: 1;
    }

    /* Links inside the dropdown */
    .dropdown-content a {
        color: black;
        padding: 8px 16px;
        text-decoration: none;
        display: block;
    }

    /* Change color of dropdown links on hover */
    .dropdown-content a:hover {background-color: #ddd}

    /* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
    .show {display:block;}

    .modal-alert-header-close{
        display: block;
        float:right;
        cursor: pointer;
        right: 0;
        margin:10px;
        width: 22px;
        height: 22px;
        background-image: url('../../assets/images/common/popup_close.png');
        background-repeat: no-repeat;
    }

    .subject-text {
        margin-top: 10px;
        display: inline-block;
        width: 100%;
        height: 34px;
        padding: 0 10px;
        vertical-align: middle;
        border: 0px;
        /* color: #fff; */
        font-weight: 900;
        font-size: 16px;
        font-family: "Noto Sans KR";
        border: 1px solid #cecece;
    }
    .material-icons {
        font-size: 21px;
        vertical-align: -6px;
    }
</style>
<style>
    .inputBox::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #ffffff !important;
        opacity: 1; /* Firefox */
    }
    
    .inputBox:focus::placeholder {
        color: #888888 !important;
    }

    .inputBox:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #ffffff !important;
    }

    .inputBox:focus:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #888888 !important;
    }

    .inputBox::-ms-input-placeholder { /* Microsoft Edge */
        color: #ffffff !important;
    }

    .inputBox:focus::-ms-input-placeholder { /* Microsoft Edge */
        color: #888888 !important;
    }
</style>